import type { Address } from 'viem'

/**
 * GMX V2 read-side contracts per chain (the data-side counterpart to the
 * calldata-sdk's `GMX_CONTRACTS`). `reader` and `glvReader` are the
 * SyntheticsReader / GlvReader view contracts; `dataStore` holds the
 * per-account request-key sets used for pending-ticket enumeration.
 *
 * Addresses pinned from the GMX frontend SDK config and verified to have
 * bytecode on-chain (both chains).
 */
export interface GmxReadContracts {
  reader: Address
  glvReader: Address
  dataStore: Address
}

export const GMX_READ_CONTRACTS: { [chainId: string]: GmxReadContracts } = {
  '42161': {
    reader: '0x470fbC46bcC0f16532691Df360A07d8Bf5ee0789',
    glvReader: '0x2C670A23f1E798184647288072e84054938B5497',
    dataStore: '0xFD70de6b91282D8017aA4E741e9Ae325CAb992d8',
  },
  '43114': {
    reader: '0x62Cb8740E6986B29dC671B2EB596676f60590A5B',
    glvReader: '0x5C6905A3002f989E1625910ba1793d40a031f947',
    dataStore: '0x2F0b22339414ADeD7D5F06f9D604c7fF5b2fe3f6',
  },
}

export const getGmxReadContracts = (
  chainId: string,
): GmxReadContracts | undefined => GMX_READ_CONTRACTS[chainId]
